import React from "react";
import "../styles/Footer.css";
const Footer = () => {
    return (
        <>
            <footer>
                <div className="container">
                    <h5>
                        © Copyright 2023 CivilAid.
                        <span>All Rights Reserved</span>
                    </h5>
                </div>
            </footer>
        </>
    );
};

export default Footer;
